var map = {
	"./1.png": 1208,
	"./2.png": 2051,
	"./3.png": 4938,
	"./4.png": 9605,
	"./5.png": 2092,
	"./6.png": 823,
	"./7.png": 7182,
	"./8.png": 2745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6766;